
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';


@Injectable({
  providedIn: 'root'
})
export class SpinnerHttpInterceptorService implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) { }

  /*
  API calls always go though interceptor, so it shows spinner and then when call returns if hides
  */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // URLs or patterns to exclude from showing the spinner
    // const excludedUrls = [''];
    const excludedPatterns = [
      /\/abs\/asset\/[a-f0-9]{32}$/i,  // Exclude /abs/asset/{uuid}
      /\/assets\/create-bulk$/i        // Exclude /assets/create-bulk
    ];
    // Extract the path portion of the URL (ignoring the domain)
    const urlPath = new URL(req.url, window.location.origin).pathname;

    // Check if the request URL matches any of the excluded URLs or patterns
    // const shouldExclude = excludedUrls.some(url => req.url.includes(url)) || excludedPatterns.some(pattern => pattern.test(req.url));
    const shouldExclude = excludedPatterns.some(pattern => pattern.test(urlPath));

    if (shouldExclude) {
      // If the request matches an excluded URL or pattern, skip showing the spinner
      return next.handle(req);
    }

    this.spinnerService.show();
    return next.handle(req).pipe(
      finalize(() => {
        this.spinnerService.hide();
      })
    );
  }
}
